import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  padding: 0;
  margin-left: 40px;
  margin-bottom: 50px;
  padding-bottom: 50px;

  ${media.medium`
    min-height: 100vh;
    margin: 0;
    padding: 110px 0 15vw 25%;
  `}
`;
